// extracted by mini-css-extract-plugin
export default {"caption":"SectionFluidImage_caption__DFJCX","imgIcon":"SectionFluidImage_imgIcon__h4JTl","sectionFluidImage":"SectionFluidImage_sectionFluidImage__eejXt"};